import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import React from "react";

export interface ChecklistDetailsProps {
  handleTaskItemNameChange: (event: any) => void;
  name: string;
  options: FormOption[];
  onOptionAdd: (option: FormOption) => void;
  onOptionRemove: (option: FormOption) => void;
  onOptionEdit: (option: FormOption) => void;
}

function ChecklistDetails({
  name,
  options,
  handleTaskItemNameChange,
  onOptionAdd,
  onOptionEdit,
  onOptionRemove,
}: ChecklistDetailsProps) {
  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Prompt",
      type: "text",
      onChange: handleTaskItemNameChange,
      xs: 12,
      sm: 6,
      id: "taskItemName",
      value: name,
    },
    {
      title: "Add Checklist Items",
      type: "addList",
      options: options,
      xs: 12,
      sm: 6,
      id: "addCheckListItems",
      onChange: () => {},
      onOptionAdd,
      onOptionEdit,
      onOptionRemove,
    },
  ];
  return <ConfigForm title="Configure Checklist" inputs={inputs}></ConfigForm>;
}

export default ChecklistDetails;
